import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'shared-group-select-children',
  templateUrl: './group-select-children.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GroupSelectChildrenComponent),
      multi: true,
    },
  ],
})
export class GroupSelectChildrenComponent implements ControlValueAccessor {
  @Input() items: any[] = [];

  @Input() bindLabel = 'name';
  @Input() bindValue = 'id';
  @Input() groupBy = 'userType';
  @Input() groupIcons: Record<string, string> = {};

  @Input() multiple = true;
  @Input() searchable = true;
  @Input() clearable = true;
  @Input() loading = false;

  @Input() placeholder = 'words.all';
  @Input() loadingText = 'words.loading';
  @Input() notFoundText = 'words.noItemsFound';

  /**
   * Ejemplo:
   * pageManagement.promotionManagement.userType.
   *
   * Resultado:
   * pageManagement.promotionManagement.userType.admin
   */

  @Input() groupTranslatePrefix = '';

  @Output() searchTermChange = new EventEmitter<string>();
  @Output() scrollEnd = new EventEmitter<void>();
  @Output() clearSelect = new EventEmitter<void>();

  value: any[] = [];
  disabled = false;

  private onChange: (value: any[]) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any[]): void {
    this.value = value ?? [];
  }

  registerOnChange(fn: (value: any[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(value: any[]): void {
    this.value = value ?? [];
    this.onChange(this.value);
    this.onTouched();
  }

  onSearch(event: { term: string; items: any[] }): void {
    this.searchTermChange.emit(event?.term ?? '');
  }

  onClear(): void {
    this.clearSelect.emit();
  }

  getGroupLabel(item: any): string {
    const groupValue = item?.[this.groupBy];

    if (!groupValue) {
      return '';
    }

    return this.groupTranslatePrefix ? `${this.groupTranslatePrefix}${groupValue}` : groupValue;
  }

  getGroupIcon(item: any): string {
    const groupValue = item?.[this.groupBy];

    return this.groupIcons[groupValue] ?? this.groupIcons['default'] ?? '';
  }
}
